import { branchDetailsRepository } from '@/forms/api/repository-factory';
import store from '@/store';
import {
    SET_BRANCH_CODES,
    SET_EMPLOYEE_CODES,
    SET_PRODUCTS,
} from '@/lib/constants/mutations';


// export default {
//     async getBranchDetails(currentStep, callbacks) {
//       const { form } = currentStep;
//       let response = false;
//       response = await callApi({
//         callbacks,
//         form,
//         formElement: currentStep,
//         apiCall: branchDetailsRepository.getBranchDetails,

//       });
//     }
//   };
export default {
    async getBranchDetails() {
        // if (store.state.institutions.length === 0) {
        let response = false;
        response = await branchDetailsRepository.getBranchDetails();
        if (response) {
            var data = response.data;
            console.log(data);
            return data;
        }
    }
};